/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Reducer of Logging
 *
 * @author Aleksandr Perkhunov
 * @version 1.1.1
 * @since 1.1.1
 */
import produce from 'immer';

import { ILoggingActionTypes } from './loggingActions';
import { LOG_BUSINESS_EVENT, LOG_BUSINESS_EVENT_FAILED, LOG_BUSINESS_EVENT_SUCCESS } from './loggingConstants';

export interface ILoggingReducer {};

export const initialState: ILoggingReducer = {};

const loggingReducer = (state = initialState, action: ILoggingActionTypes) =>
    produce(state, () => {
        switch (action.type) {
            case LOG_BUSINESS_EVENT:
                break;
            case LOG_BUSINESS_EVENT_SUCCESS:
                break;
            case LOG_BUSINESS_EVENT_FAILED:
                break;
            default:
                return state;
        }
    });

export default loggingReducer;
